export const ABOUT_BRAND_SECTION_ID = 'about-brand'
